/*
  Caasi leverbelofte - gedeelde berekening
  ----------------------------------------
  Eén bron voor de levertijd. Stond eerder als losse kopie in
  snippets/product-buy-buttons.liquid en sections/announcement-bar.liquid.
  Een vierde kopie zat in sections/caasi-usp-bar.liquid; die sectie werd
  door geen enkel template gebruikt en is verwijderd. De regels zijn
  ongewijzigd uit die bestanden overgenomen:

    - verzenden op ma t/m vr, niet op feestdagen
    - bezorgen op ma t/m za, niet op feestdagen
    - cutoff 18:00, daarna schuift het naar de eerstvolgende verzenddag
    - levering = eerstvolgende bezorgdag na de verzenddag

  Gebruik in liquid:
    <span data-caasi-delivery="short"></span>         Morgen in huis
    <span data-caasi-delivery="full"></span>          Morgen in huis - dinsdag 18 augustus
    <span data-caasi-delivery="countdown"></span>     Bestel binnen 5 uur, 12 min en 3 sec
    <span data-caasi-delivery="usp"></span>           Bestel binnen 5u12m, MORGEN in huis
    <span data-caasi-delivery="announcement"></span>  Bestel binnen 5 uur en 12 minuten, MORGEN in huis

  Het land staat op <html data-caasi-land> (layout/theme.liquid).

    Nederland: deze regels.
    Belgie: dezelfde regels, plus de Belgische feestdagen als dag zonder bezorging.
      Verzenden blijft de Nederlandse kalender, en een Nederlandse feestdag blijft
      ook voor Belgie een dag zonder bezorging, want het pakket gaat via PostNL in
      Nederland. Zaterdag blijft een bezorgdag: 5 van de 45 BE-zendingen kregen de
      eerste bezorgpoging op zaterdag. Rond een Belgische feestdag is niets gemeten.
    Duitsland: vast 2 werkdagen, zonder datum en zonder afteller (besluit Isaac
      03-11-2026, gemeten op maar 1 zending).

  De formaten usp en announcement leveren html (met <strong>), de rest tekst.
  Announcement is smal-afhankelijk: onder 768px wordt het
  "Nog 5 uur en 12 min - morgen thuis". Dat verving een reeks letterlijke
  tekstvervangingen in layout/theme.liquid, die op innerHTML werkten en
  daardoor stilzwijgend faalden zodra er <strong> in de tekst stond.

  Elementen die later worden toegevoegd (filters, oneindig scrollen,
  section rendering) worden vanzelf meegenomen.
*/
(function () {
  'use strict';

  var CUTOFF_HOUR = 18;
  var HOLIDAYS = ['2026-01-01','2026-04-05','2026-04-06','2026-04-27','2026-05-14','2026-05-24','2026-05-25','2026-12-25','2026-12-26','2027-01-01','2027-03-28','2027-03-29','2027-04-27','2027-05-06','2027-05-16','2027-05-17','2027-12-25','2027-12-26'];
  /* Taal volgt de winkel (<html lang>): /en/ krijgt Engels, de rest Nederlands. */
  var EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var DAYS_NL = EN
    ? ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday']
    : ['zondag','maandag','dinsdag','woensdag','donderdag','vrijdag','zaterdag'];
  var MONTHS_NL = EN
    ? ['January','February','March','April','May','June','July','August','September','October','November','December']
    : ['januari','februari','maart','april','mei','juni','juli','augustus','september','oktober','november','december'];

  /* Belgische feestdagen die in Nederland geen feestdag zijn: 1 mei, 21 juli, 15 augustus, 1 en 11 november. */
  var HOLIDAYS_BE = ['2026-11-01','2026-11-11','2027-05-01','2027-07-21','2027-08-15','2027-11-01','2027-11-11'];
  var LEVERTIJD_DE = EN ? '2 working days' : '2 werkdagen';

  function land() {
    return document.documentElement.getAttribute('data-caasi-land');
  }

  function dagSleutel(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }

  function isHoliday(d) {
    return HOLIDAYS.indexOf(dagSleutel(d)) >= 0;
  }

  function isShipDay(d) { var w = d.getDay(); return w >= 1 && w <= 5 && !isHoliday(d); }
  function isDeliveryDay(d, belgie) {
    var w = d.getDay();
    return w >= 1 && w <= 6 && !isHoliday(d) && !(belgie && HOLIDAYS_BE.indexOf(dagSleutel(d)) >= 0);
  }

  function nextDeliveryDay(d, belgie) {
    var next = new Date(d);
    next.setDate(next.getDate() + 1);
    while (!isDeliveryDay(next, belgie)) next.setDate(next.getDate() + 1);
    return next;
  }

  function getNextCutoff(now) {
    var cutoff = new Date(now);
    cutoff.setHours(CUTOFF_HOUR, 0, 0, 0);
    if (isShipDay(now) && now < cutoff) return cutoff;
    var next = new Date(now);
    next.setDate(next.getDate() + 1);
    while (!isShipDay(next)) next.setDate(next.getDate() + 1);
    next.setHours(CUTOFF_HOUR, 0, 0, 0);
    return next;
  }

  function daysBetween(a, b) {
    var da = new Date(a.getFullYear(), a.getMonth(), a.getDate());
    var db = new Date(b.getFullYear(), b.getMonth(), b.getDate());
    return Math.round((db - da) / 86400000);
  }

  function formatDate(d) {
    return DAYS_NL[d.getDay()] + ' ' + d.getDate() + ' ' + MONTHS_NL[d.getMonth()];
  }

  function deliveryWord(days, delivery) {
    if (EN) {
      if (days <= 1) return 'tomorrow';
      if (days === 2) return 'the day after tomorrow';
      return 'on ' + DAYS_NL[delivery.getDay()];
    }
    if (days <= 1) return 'morgen';
    if (days === 2) return 'overmorgen';
    return DAYS_NL[delivery.getDay()];
  }

  function capitalize(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  function compute(now) {
    var belgie = land() === 'BE';
    var cutoff = getNextCutoff(now);
    var delivery = nextDeliveryDay(cutoff, belgie);
    var remaining = cutoff - now;

    if (remaining <= 0) {
      cutoff = getNextCutoff(new Date(now.getTime() + 1000));
      delivery = nextDeliveryDay(cutoff, belgie);
      remaining = cutoff - now;
    }

    var days = daysBetween(now, delivery);

    return {
      cutoff: cutoff,
      delivery: delivery,
      remaining: remaining,
      days: days,
      word: deliveryWord(days, delivery),
      geenMorgen: belgie && delivery.getTime() !== nextDeliveryDay(cutoff, false).getTime(),
      hours: Math.floor(remaining / 3600000),
      minutes: Math.floor((remaining % 3600000) / 60000),
      seconds: Math.floor((remaining % 60000) / 1000)
    };
  }

  function text(format, state) {
    if (land() === 'DE') {
      if (format === 'countdown' || format === 'date') return '';
      if (format === 'full') return EN ? 'Delivered in ' + LEVERTIJD_DE : 'In ' + LEVERTIJD_DE + ' in huis';
      /* short staat op de productkaarten: de hele zin past daar niet op een regel. */
      return 'In ' + LEVERTIJD_DE;
    }
    switch (format) {
      case 'full':
        if (EN) return 'Delivered ' + state.word + ' - ' + formatDate(state.delivery);
        return capitalize(state.word) + ' in huis - ' + formatDate(state.delivery);
      case 'countdown':
        if (EN) {
          var uit = 'Order within ';
          if (state.hours > 0) uit += state.hours + (state.hours === 1 ? ' hour, ' : ' hours, ');
          return uit + state.minutes + ' min';
        }
        var out = 'Bestel binnen ';
        if (state.hours > 0) out += state.hours + ' uur, ';
        return out + state.minutes + ' min';
      case 'date':
        return formatDate(state.delivery);
      default:
        if (EN) return 'Delivered ' + state.word;
        return capitalize(state.word) + ' in huis';
    }
  }

  function wanneerHtml(state, kleineLetters) {
    if (EN) {
      var w = state.days <= 1 ? 'tomorrow' : (state.days === 2 ? 'the day after tomorrow' : DAYS_NL[state.delivery.getDay()]);
      return (state.days > 2 ? 'on ' : '') + '<strong>' + (kleineLetters ? w : w.toUpperCase()) + '</strong>';
    }
    var woord;
    if (state.days <= 1) woord = 'morgen';
    else if (state.days === 2) woord = 'overmorgen';
    else woord = DAYS_NL[state.delivery.getDay()];
    return '<strong>' + (kleineLetters ? woord : woord.toUpperCase()) + '</strong>';
  }

  function smalScherm() {
    return window.innerWidth < 768;
  }

  function html(format, state) {
    if (land() === 'DE') {
      return EN
        ? 'Delivered in <strong>' + LEVERTIJD_DE.toUpperCase() + '</strong>'
        : 'In <strong>' + LEVERTIJD_DE.toUpperCase() + '</strong> in huis';
    }
    if (EN) {
      if (format === 'announcement') {
        if (smalScherm()) {
          return state.hours + ' h ' + state.minutes + ' min left - delivered ' + wanneerHtml(state, true);
        }
        return 'Order within ' + state.hours + (state.hours === 1 ? ' hour' : ' hours') + ' and ' + state.minutes +
          (state.minutes === 1 ? ' minute, ' : ' minutes, ') + 'delivered ' + wanneerHtml(state);
      }
      return 'Order within ' + state.hours + 'h' + state.minutes + 'm, delivered ' + wanneerHtml(state);
    }
    if (format === 'announcement') {
      if (smalScherm()) {
        return 'Nog ' + state.hours + ' uur en ' + state.minutes + ' min - ' +
          wanneerHtml(state, true) + ' thuis';
      }
      return 'Bestel binnen ' + state.hours + ' uur en ' + state.minutes +
        (state.minutes === 1 ? ' minuut, ' : ' minuten, ') + wanneerHtml(state) + ' in huis';
    }
    return 'Bestel binnen ' + state.hours + 'u' + state.minutes + 'm, ' +
      wanneerHtml(state) + ' in huis';
  }

  var HTML_FORMATS = ['usp', 'announcement'];

  function refresh() {
    var state = compute(new Date());

    /* Belgie, de dag voor een feestdag: de berekende datum klopt al, de vaste zinnen met "morgen" wijken. */
    if (state.geenMorgen) {
      document.documentElement.setAttribute('data-caasi-geen-morgen', '');
      var vast = document.querySelectorAll('[data-caasi-zonder-morgen]');
      for (var v = 0; v < vast.length; v++) vast[v].textContent = vast[v].getAttribute('data-caasi-zonder-morgen');
    } else {
      document.documentElement.removeAttribute('data-caasi-geen-morgen');
    }

    var nodes = document.querySelectorAll('[data-caasi-delivery]');
    if (!nodes.length) return false;

    var hasCountdown = false;

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var format = el.getAttribute('data-caasi-delivery') || 'short';

      if (format === 'countdown' || format === 'usp') hasCountdown = true;
      /* Uren als getal voor scripts die erop reageren (productpagina), los van de taal. */
      if (format === 'countdown') el.setAttribute('data-uren', state.hours);

      if (HTML_FORMATS.indexOf(format) !== -1) {
        var markup = html(format, state);
        if (el.getAttribute('data-caasi-rendered') !== markup) {
          el.innerHTML = markup;
          el.setAttribute('data-caasi-rendered', markup);
        }
      } else {
        var value = text(format, state);
        if (el.getAttribute('data-caasi-rendered') !== value) {
          el.textContent = value;
          el.setAttribute('data-caasi-rendered', value);
        }
      }

      el.removeAttribute('hidden');
    }

    return hasCountdown;
  }

  var timer = null;

  function schedule() {
    var hasCountdown = refresh();
    var wait = hasCountdown ? 1000 : 15000;
    clearTimeout(timer);
    timer = setTimeout(schedule, wait);
  }

  window.CaasiDelivery = {
    compute: compute,
    text: text,
    refresh: refresh,
    formatDate: formatDate
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  document.addEventListener('shopify:section:load', refresh);

  // Het announcement-formaat is smaller-afhankelijk, dus bij draaien of
  // vergroten opnieuw renderen zonder op de volgende tik te wachten.
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(refresh, 200);
  });
})();
